// src/pages/CapturePage/captureApi.js
// Every capture call in one place, so a route change is one edit.
import api from '../../services/api';

export const getProtocol = () => api.get('/case-history/capture-protocol');

export const openSession = (caseId, notes) =>
    api.post(`/case-history/cases/${caseId}/capture-sessions`, { notes: notes || null });
export const listSessions = (caseId) => api.get(`/case-history/cases/${caseId}/capture-sessions`);
export const getSession = (sessionId) => api.get(`/case-history/capture-sessions/${sessionId}`);

export const savePreflight = (sessionId, fields) =>
    api.put(`/case-history/capture-sessions/${sessionId}`, fields);
export const completeSession = (sessionId) =>
    api.post(`/case-history/capture-sessions/${sessionId}/complete`);

export const saveDdkTask = (sessionId, task, body) =>
    api.put(`/case-history/capture-sessions/${sessionId}/ddk/${task}`, body);
export const saveVoiceSample = (sessionId, body) =>
    api.post(`/case-history/capture-sessions/${sessionId}/voice`, body);
export const saveOralMotor = (sessionId, body) =>
    api.post(`/case-history/capture-sessions/${sessionId}/oral-motor`, body);

export const BLOCK_STATE_LABEL = {
    none: 'Not started',
    partial: 'Part done',
    complete: 'Done',
};

// What the server said, in words a person can act on. An upload refused for a
// missing pre-flight field or a withdrawn consent must not read as "error".
export const captureError = (err, fallback = 'Something went wrong. Try again.') =>
    err?.response?.data?.detail || fallback;
